module.exports = __webpack_public_path__ + "img/partner05.00706ab6.png";